import { cache } from "../../../../../../cache";
import { FileSuffix } from "../../../../models";
// TODO: When importers/exporters are in core, we dont need to pass these methods
export const parseFootprintData = (footprintNodeUid, footprintAssetRule, storageName, kicadFootprintToFluxFootprint) => {
    return cache(() => {
        if (!footprintAssetRule?.value) {
            return;
        }
        const fileType = getFileType(footprintAssetRule.payloadFileName, storageName);
        switch (fileType) {
            case FileSuffix.modFile:
            case FileSuffix.kicadModFile:
                return Object.values(
                //
                kicadFootprintToFluxFootprint(fileType, atob(footprintAssetRule?.payloadAsBase64 ?? "")) ?? {})[0];
            case FileSuffix.fluxFootprintFile:
                return JSON.parse(atob(footprintAssetRule?.payloadAsBase64 ?? ""));
        }
        return undefined;
    }, "parseFootprintData", [footprintAssetRule?.payloadAsBase64, footprintNodeUid]);
};
export const getFileType = (payloadFileName, storageName) => {
    const filename = !payloadFileName ? storageName?.toLowerCase() : payloadFileName.toLowerCase();
    if (filename?.endsWith(FileSuffix.kicadModFile)) {
        return FileSuffix.kicadModFile;
    }
    else if (filename?.endsWith(FileSuffix.modFile)) {
        return FileSuffix.modFile;
    }
    else if (filename?.endsWith(FileSuffix.fluxFootprintFile)) {
        return FileSuffix.fluxFootprintFile;
    }
    return undefined;
};
//# sourceMappingURL=parseFootprintData.js.map